<vc-pie-chart
    [contentHeight]="contentHeight"
    [title]="title"
    [seriesPieOptions]="series"
    [loading]="loading"
    [legendOptions]="legendOptions"
    [pointClick]="onPointClick"
    [tooltipFormat]="tooltipFormat || ''">
    @if (chartWrapperEndTemplate) {
        <ng-template #chartWrapperEnd>
            <ng-container *ngTemplateOutlet="chartWrapperEndTemplate"></ng-container>
        </ng-template>
    }
    <ng-content></ng-content>
</vc-pie-chart>
